import { pageHeaderHeight, pageTitleHeight, tableToolbarHeight, tabListHeight } from '@/constants'
import { useLayout } from '@/providers'
import { useBoolVariation } from '@launchdarkly/react-sdk'

type Options = {
	pageTitle?: boolean
	tabList?: boolean
	tableToolbar?: boolean
	extra?: string[]
}

/**
 * Calculates the available page height below the app's global chrome (app bar,
 * announcement banner, and the new page header when enabled) and any page-specific
 * chrome the caller indicates is present above their content.
 *
 * @example
 * const height = usePageHeight({ pageTitle: true, tableToolbar: true })
 */
export default function usePageHeight({
	pageTitle = false,
	tabList = false,
	tableToolbar = false,
	extra = [],
}: Options = {}): string {
	const { appBarHeight, announcementHeight } = useLayout()
	const uiUpdateEnabled = useBoolVariation('feature-art-1553-new-ui-layout', false)

	const heights = [
		appBarHeight,
		announcementHeight,
		...(uiUpdateEnabled ? [pageHeaderHeight] : []),
		...(pageTitle ? [pageTitleHeight] : []),
		...(tabList ? [tabListHeight] : []),
		...(tableToolbar ? [tableToolbarHeight] : []),
		...extra,
	]

	return `calc(100vh - ${heights.join(' - ')})`
}
